import React, { useEffect } from 'react'

export const useAuthGuard = ({ 
    user, 
    authLoaded, 
    authLoading, 
    location, 
    navigate,
}) => {
    useEffect(() => {
        console.log("useAuthGuard", {
            authLoaded,
            authLoading
        })
        if (!authLoaded || authLoading) return;

        const currentPath = location.pathname;
        const publicPaths = ['/login', '/register', '/home'];
        const isPublicRoute = publicPaths.some(path => currentPath.startsWith(path));

        // 👇 Only redirect if not public AND not authenticated
        if (!user && !isPublicRoute) {
            navigate('/login', {
                replace: true,
                state: { from: location },
            });
        }
    }, [user, authLoaded, authLoading, location.pathname]);
};
